/**
 * Minimum browser capability gate — shown before React boots when unsupported.
 */

const MIN_FEATURES = [
  () => typeof Promise !== "undefined",
  () => typeof fetch !== "undefined",
  () => typeof Intl !== "undefined",
  () => typeof structuredClone !== "undefined",
  () => "noModule" in HTMLScriptElement.prototype,
] as const;

export function isBrowserSupported(): boolean {
  try {
    return MIN_FEATURES.every((check) => check());
  } catch {
    return false;
  }
}

export function renderUnsupportedBrowser(): void {
  const root = document.getElementById("root");
  if (!root) return;

  root.innerHTML = `
    <div style="
      font-family: system-ui, -apple-system, sans-serif;
      max-width: 28rem;
      margin: 4rem auto;
      padding: 0 1.5rem;
      color: #18181b;
      line-height: 1.6;
    ">
      <h1 style="font-size: 1.25rem; font-weight: 600; margin-bottom: 0.75rem;">
        Browser not supported
      </h1>
      <p style="color: #52525b; font-size: 0.9375rem; margin-bottom: 1rem;">
        Office Rhythm needs a modern browser with ES modules and current web APIs.
        Please update Safari, Chrome, Firefox, or Edge to the latest version.
      </p>
      <p style="color: #71717a; font-size: 0.8125rem;">
        Supported: last 2 versions of Chrome, Firefox, Safari, and Edge.
      </p>
    </div>
  `;
}
